import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { themeGet, Box, Spinner, Text } from '@primer/react';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
import { truncateTextFromMiddle } from '../../utils/functions.js';
import LTButton from '../LTButton/index.js';
import LTCounterLabel from '../LTCounterLabel/index.js';
import LTPopover from '../LTPopover/index.js';
import LTTag from '../LTTags/index.js';
import LTText from '../LTText/index.js';
import LTTestStatusLabel from '../LTTestStatusLabel/index.js';
import LTTooltip from '../LTTooltip/index.js';
import ClockIcon from '../../icons/ClockIcon.js';
import styles from './index.module.css.js';

var Dot = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), themeGet("colors.fg.disabled"));
var TestCardWrapper = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  padding: 12px 16px;\n  border-bottom: 1px solid ", ";\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  &:hover {\n    background-color: #dddddd33;\n  }\n"], ["\n  display: flex;\n  gap: ", ";\n  padding: 12px 16px;\n  border-bottom: 1px solid ", ";\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  &:hover {\n    background-color: #dddddd33;\n  }\n"])), themeGet("space.2"), themeGet("colors.border.default"));
var IconDescriptionText = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n"])), themeGet("colors.fg.default"));
var InfoList = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 0px;\n  margin: 0px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"], ["\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 0px;\n  margin: 0px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"])), themeGet("space.2"));
var Item = styled.li(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), themeGet("space.2"));
var ToolTipTag = function ToolTipTag(_a) {
  var tags = _a.tags,
    totalCount = _a.totalCount;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      gap: themeGet("space.2"),
      alignItems: "start",
      flexDirection: "column"
    }
  }, tags.slice(2, totalCount).map(function (tag, index) {
    var _a = (tag || {}).name,
      name = _a === void 0 ? "" : _a;
    return /*#__PURE__*/React.createElement(LTTooltip, {
      text: name,
      key: "".concat(name, "-").concat(index)
    }, /*#__PURE__*/React.createElement(LTTag, {
      text: name
    }));
  }));
};
var LTTestCard = function LTTestCard(_a) {
  var _b = _a.accessibilityIcon,
    AccessibilityIcon = _b === void 0 ? null : _b,
    _c = _a.autoHealIcon,
    AutoHealIcon = _c === void 0 ? null : _c,
    _d = _a.testName,
    testName = _d === void 0 ? "" : _d,
    _e = _a.osIcon,
    osIcon = _e === void 0 ? "" : _e,
    _f = _a.browserIcon,
    browserIcon = _f === void 0 ? "" : _f,
    _g = _a.flakyIcon,
    FlakyTestIcon = _g === void 0 ? null : _g,
    _h = _a.notesIcon,
    notesIcon = _h === void 0 ? "" : _h,
    _j = _a.browser,
    browser = _j === void 0 ? "" : _j,
    _k = _a.timeTaken,
    timeTaken = _k === void 0 ? "" : _k,
    _l = _a.testTimeSince,
    testTimeSince = _l === void 0 ? "" : _l,
    _m = _a.onLiveInteractionClick,
    onLiveInteractionClick = _m === void 0 ? function () {} : _m,
    _o = _a.reason,
    reason = _o === void 0 ? "" : _o,
    _p = _a.index,
    index = _p === void 0 ? "" : _p,
    _q = _a.isFlaky,
    isFlaky = _q === void 0 ? false : _q,
    _r = _a.tags,
    tags = _r === void 0 ? [] : _r,
    _s = _a.isAccessibilityEnabled,
    isAccessibilityEnabled = _s === void 0 ? false : _s,
    _t = _a.isAutoHeal,
    isAutoHeal = _t === void 0 ? false : _t,
    _u = _a.showLiveInteraction,
    showLiveInteraction = _u === void 0 ? false : _u,
    _v = _a.isSampleBuild,
    isSampleBuild = _v === void 0 ? false : _v,
    _w = _a.version,
    version = _w === void 0 ? "" : _w,
    _x = _a.osVersion,
    osVersion = _x === void 0 ? "" : _x,
    _y = _a.osName,
    osName = _y === void 0 ? "" : _y,
    _z = _a.testStatus,
    testStatus = _z === void 0 ? "" : _z,
    _0 = _a.testCardStyle,
    testCardStyle = _0 === void 0 ? "" : _0,
    _1 = _a.testStatusIcon,
    testStatusIcon = _1 === void 0 ? null : _1;
  var totalTags = Array.isArray(tags) ? Number(tags.length) : 0;
  var remainingTagCount = Array.isArray(tags) ? Number(totalTags) - 2 : 0;
  var truncatedTestName = truncateTextFromMiddle(testName, 90);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TestCardWrapper, {
    className: "".concat(testCardStyle, " ").concat(index === 0 ? styles.firstTestItem : "")
  }, /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.RIGHT,
    text: capitalize(testStatus)
  }, testStatusIcon ? /*#__PURE__*/React.createElement(LTTestStatusLabel, {
    iconSrc: testStatusIcon,
    status: testStatus,
    showStatusText: false,
    width: 16,
    height: 16
  }) : /*#__PURE__*/React.createElement(Spinner, {
    size: "small",
    sx: {
      color: "#0366D6",
      fill: "#0366D6",
      fillOpacity: "0.1"
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    direction: LTTooltip.Direction.BOTTOM,
    text: testName
  }, /*#__PURE__*/React.createElement(LTText, {
    "aria-hidden": "true",
    as: "h4",
    sx: {
      color: "fg.default",
      lineHeight: "20px",
      margin: 0,
      wordBreak: "break-word"
    },
    variant: LTText.TextVariant.SUBHEADER_BOLD
  }, truncatedTestName)), tags && tags.length > 0 && tags.slice(0, 2).map(function (tag) {
    var _a = (tag || {}).name,
      name = _a === void 0 ? "" : _a;
    return /*#__PURE__*/React.createElement(LTTag, {
      ariaHidden: true,
      text: name,
      toolTipDirection: LTTooltip.Direction.BOTTOM
    });
  }), remainingTagCount > 0 && /*#__PURE__*/React.createElement(LTPopover, {
    ariaDescribedBy: "lt-test-card-popover-".concat(index),
    text: /*#__PURE__*/React.createElement(ToolTipTag, {
      totalCount: totalTags,
      tags: tags
    })
  }, /*#__PURE__*/React.createElement(LTCounterLabel, {
    count: "+".concat(remainingTagCount),
    scheme: LTCounterLabel.Scheme.OUTLINED
  }))), reason && /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": "true",
    sx: {
      display: "flex",
      alignItems: "start",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: notesIcon,
    alt: "notes",
    style: {
      marginTop: "3px"
    }
  }), /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: "fg.muted",
      wordBreak: "break-word",
      lineHeight: "20px"
    }
  }, reason)), /*#__PURE__*/React.createElement(InfoList, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, timeTaken && /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    text: "Total Time"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement(ClockIcon, {
    ariaLabel: "Time Taken"
  }), /*#__PURE__*/React.createElement(IconDescriptionText, null, timeTaken))), /*#__PURE__*/React.createElement(Dot, null)), /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    text: capitalize(browser)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: browserIcon,
    alt: "".concat(browser || version, " browser"),
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(IconDescriptionText, {
    sx: {
      fontWeight: "600 !important"
    }
  }, version))), /*#__PURE__*/React.createElement(Dot, null)), /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(LTTooltip, {
    text: capitalize(osName)
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: osIcon,
    alt: "".concat(osName || osVersion, " os"),
    height: "16",
    width: "16"
  }), /*#__PURE__*/React.createElement(IconDescriptionText, {
    sx: {
      fontWeight: "600 !important"
    }
  }, osVersion))), isAccessibilityEnabled && /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    text: "Accessibility Enabled"
  }, /*#__PURE__*/React.createElement(AccessibilityIcon, {
    height: "16",
    width: "16"
  }))), !isSampleBuild && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    text: "Time Since"
  }, /*#__PURE__*/React.createElement(Text, {
    sx: {
      color: "fg.default",
      fontSize: "12px"
    }
  }, testTimeSince)))), isFlaky && /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    text: "Flaky Test"
  }, /*#__PURE__*/React.createElement(FlakyTestIcon, {
    height: "16",
    width: "16"
  }))), isAutoHeal && /*#__PURE__*/React.createElement(Item, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(LTTooltip, {
    text: "Auto Healed"
  }, /*#__PURE__*/React.createElement(AutoHealIcon, {
    height: "16",
    width: "16"
  }))), showLiveInteraction && /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.liveInteractionBtn)
  }, /*#__PURE__*/React.createElement(LTButton, {
    id: "test-card-live-interaction-button-".concat(index),
    onClick: function onClick() {
      return onLiveInteractionClick(osName);
    },
    variant: "default"
  }, "Live Interaction")))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { LTTestCard as default };
